var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1334_811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2173 19.7912C24.4009 13.781 29.5589 7.80093 34.7814 1.74528C33.6227 1.97191 32.5595 2.18076 31.462 2.39628C31.372 1.94635 31.2875 1.53198 31.1953 1.07428C31.9952 0.910972 32.7651 0.752109 33.536 0.59658C34.4737 0.406611 35.4124 0.219976 36.3511 0.0322294C36.9966 -0.096638 37.3421 0.178872 37.3432 0.837651C37.3465 2.44849 37.3443 4.05934 37.3443 5.67018C37.3443 5.76461 37.3443 5.85904 37.3443 5.97568H36.0367V2.50848C35.9812 2.46627 35.9257 2.42294 35.8701 2.38073C35.8212 2.4896 35.7957 2.61735 35.7212 2.70401C30.4988 8.76188 25.273 14.8164 20.0472 20.871C19.5661 21.4287 19.364 21.4598 18.7374 21.0732C16.2212 19.5234 13.7049 17.9726 11.1887 16.4228C11.0831 16.3584 10.9754 16.2984 10.8265 16.2129C8.29136 19.379 5.76178 22.5396 3.19776 25.7413C2.85337 25.4691 2.52232 25.2069 2.16016 24.9192C2.71006 24.2293 3.2422 23.5583 3.77766 22.8895C5.85065 20.2988 7.92475 17.7082 9.99885 15.1175C10.4254 14.5842 10.6565 14.5398 11.232 14.8931C13.7393 16.4317 16.2445 17.9726 18.7507 19.5123C18.8918 19.599 19.0351 19.6812 19.2173 19.79V19.7912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0102 31.6647C14.0102 34.1365 14.0102 36.6083 14.0102 39.0801C14.0102 39.7878 13.8013 39.9967 13.0925 39.9967C11.8983 39.9967 10.7041 39.9989 9.5087 39.9967C8.91102 39.9944 8.67773 39.7611 8.67661 39.1635C8.6755 34.1643 8.6755 29.164 8.67661 24.1648C8.67661 23.5661 8.90991 23.3339 9.5087 23.3328C10.7307 23.3294 11.9527 23.3294 13.1759 23.3328C13.7735 23.3339 14.0079 23.5672 14.0079 24.166C14.0102 26.6655 14.0079 29.1651 14.0079 31.6647H14.0102ZM10.0386 24.6848V38.6324H12.656V24.6848H10.0386Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6779 33.04C22.6779 35.0542 22.6779 37.0672 22.6779 39.0813C22.6779 39.7889 22.469 39.9967 21.7602 39.9978C20.566 39.9978 19.3717 40 18.1764 39.9978C17.5787 39.9956 17.3454 39.7623 17.3454 39.1635C17.3432 35.053 17.3432 30.9426 17.3454 26.8322C17.3454 26.2334 17.5787 26.0023 18.1786 26.0012C19.4006 25.9979 20.6226 25.9979 21.8458 26.0012C22.4435 26.0023 22.6768 26.2356 22.6779 26.8344C22.6801 28.9041 22.6779 30.9726 22.6779 33.0423V33.04ZM18.7063 27.351V38.6313H21.3236V27.351H18.7063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00649841 35.3308C0.00649841 34.0532 0.00427656 32.7757 0.00649841 31.4981C0.00760934 30.8993 0.239793 30.6671 0.837471 30.6649C2.05949 30.6616 3.28151 30.6616 4.50353 30.6649C5.10232 30.666 5.33672 30.8993 5.33672 31.497C5.33894 34.0521 5.33894 36.6073 5.33672 39.1624C5.33672 39.7601 5.10121 39.9945 4.50464 39.9956C3.28262 39.9989 2.0606 39.9989 0.838582 39.9956C0.240904 39.9945 0.00760934 39.7612 0.00538748 39.1635C0.00205471 37.8859 0.00538748 36.6084 0.00538748 35.3308H0.00649841ZM1.3696 32.0158V38.6303H3.98473V32.0158H1.3696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0171 22.674H27.3597V23.9716H26.0155C26.0155 23.2817 25.9933 22.6051 26.0244 21.9297C26.0411 21.5675 26.2943 21.342 26.661 21.3387C28.0074 21.3264 29.3538 21.3253 30.7014 21.3398C31.088 21.3442 31.3313 21.6175 31.3391 22.0219C31.3524 22.6596 31.3424 23.2972 31.3424 23.966H30.0171V22.674Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.011 13.3134H38.6934V12.0302H36.0216V13.31H34.693C34.693 12.6135 34.6652 11.9103 34.7052 11.2115C34.7241 10.8738 34.9952 10.6727 35.3429 10.6705C36.676 10.6627 38.0091 10.6594 39.3411 10.6705C39.7388 10.6738 39.9965 10.9315 40.0065 11.3259C40.0232 11.9758 40.011 12.6268 40.011 13.3122V13.3134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0121 37.3505H27.3319V38.6336H30.0037V37.3527H31.3301C31.3301 38.0503 31.359 38.7536 31.3179 39.4523C31.2979 39.7889 31.0257 39.99 30.678 39.9922C29.3449 40.0011 28.0129 40.0034 26.6798 39.9922C26.2832 39.9889 26.0255 39.7301 26.0166 39.3346C25.9999 38.6847 26.0121 38.0348 26.0121 37.3505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.005 37.356C40.005 38.0492 40.0283 38.7269 39.9961 39.4012C39.9784 39.7622 39.7228 39.9866 39.3562 39.99C38.0098 40.0011 36.6634 40.0044 35.3169 39.9866C34.9336 39.9811 34.697 39.73 34.6859 39.3434C34.667 38.6924 34.6803 38.0414 34.6803 37.3604H36.0068V38.6435H38.6641V37.3549H40.005V37.356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9924 16.0229V18.6325H38.707V16.0229H39.9924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9929 21.3598V23.9771H34.7109V21.3598H35.9929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.707 21.352H39.9924V23.966H38.707V21.352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.707 16.0184H35.9924V18.6324H34.707V16.0184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0391 26.6833H27.3211V29.2974H26.0391V26.6833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3127 29.3151H30.0352V26.6866H31.3127V29.3151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.707 26.6844H35.9901V29.2985H34.707V26.6844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9907 26.6877V29.2995H38.7031V26.6877H39.9907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0273 34.6309V32.0247H27.3238V34.6309H26.0273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3255 32.0213V34.632H30.0391V32.0213H31.3255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.707 32.0146H35.9857V34.6431H34.707V32.0146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9829 34.6553H38.7109V32.0291H39.9829V34.6553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0391 24.6837H12.6564V38.6313H10.0391V24.6837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7031 27.351H21.3205V38.6314H18.7031V27.351Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37109 32.0157H3.98621V38.6302H1.37109V32.0157Z",
    fill: "#F89B60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1334_811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.0145,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitorIcon.635a0e1cb776235e8430128dbb967e40.svg";
export { ForwardRef as ReactComponent };